import { ASSETS_URL } from '../../Settings';
const SOUNDS_URL = `${ASSETS_URL}sounds/`;


export default class SoundLibrary {
    sounds = {};

    constructor(library) {
        this.library = library;
        this.game = library.game;
        this.app = this.game.app;

        this.getLibrary();
    }

    getLibrary = () => {
        this.game.gameApi.getLibrary('Sound');
    }

    receiveLibrary = (soundLibrary) => {
        soundLibrary.soundlibraryentry_set.forEach((soundData) => {
            let soundFileName = soundData.sound.filename;
            let soundUrl = SOUNDS_URL + soundFileName;
            this.sounds[soundData.entry_number] = new Audio(soundUrl);
        });
    };

    play = (entryNumber) => {
        if (!entryNumber) {
            return;
        }
        let account = this.app.state.authenticator.account;
        let volume = account.volume;
        let sound = this.sounds[entryNumber];
        if (sound) {
            sound.currentTime = 0;
            sound.volume = volume;
            sound.onerror = () => {
                console.warn('sound error');
                this.sounds[entryNumber] = null;
            }
            try {
                sound && sound.play();
            }
            catch {
                console.warn('Sound Error', entryNumber);
            }
            return sound;
        } else {
            console.warn('Missing Sound Entry', entryNumber)
        }
    }

    playFilename = (soundFileName, loop=false) => {
        if (!soundFileName) {
            return;
        }
        let account = this.app.state.authenticator.account;
        let volume = account.volume;
        let soundUrl = SOUNDS_URL + soundFileName;
        let sound = new Audio(soundUrl);
        if (sound) {
            sound.currentTime = 0;
            sound.volume = volume;
            sound.loop = loop;
            sound.play();
            return sound;
        } else {
            console.warn('Missing Sound Entry', soundFileName)
        }
    }
}
